export default __webpack_public_path__ + "static/media/cell.af4e8d0f.png";